import { EPrimarySideBar3IdType, EPrimarySideBar3StateType } from "app/reducers/_reducers/PrimarySidebar3Reducer";

export const IMPERSONATE_WARNING_TITLE = "Impersonating user";
export const SUBSCRIPTION_MANIPULATION_TITLE = "Subscription Manipulation";
export const SUBSCRIPTION_MANIPULATION_SUBTITLE = "This is not default subscription";
export const PACKAGE_DEMO_TOOL_TITLE = "Package demo tool";
export const UI_VERSION_TITLE = "UI Version";
export const UI_BRANCH_TITLE = "UI Branch";

export const SIDEBAR_ALWAYS_OPENED_PAGES = [
    EPrimarySideBar3IdType.Homepage,
    EPrimarySideBar3IdType.SIHome,
    EPrimarySideBar3StateType.SIHome,
];
